import React, { useEffect, useState } from "react";
import { investorApi } from "../../api/api";
import PropertyDetails from "./PropertyDetails";
import CloseIcon from "@mui/icons-material/Close";
import {
  IconButton,
  Box,
  CircularProgress,
  Typography,
  useMediaQuery,
  useTheme,
  Modal
} from "@mui/material";
import { useSelector } from "react-redux";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";

const PropertyImages = ({ data, type }) => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentType, setCurrentType] = useState('image');
  const theme = useSelector((data) => data.themeValue.colors);
  const muiTheme = useTheme();
  
  // Responsive breakpoints
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('sm')); // < 600px
  const isTablet = useMediaQuery(muiTheme.breakpoints.between('sm', 'md')); // 600px - 900px
  const isDesktop = useMediaQuery(muiTheme.breakpoints.up('md')); // > 900px
  
  const [propertyVideos, setPropertyVideos] = useState([]);
  const [allMedia, setAllMedia] = useState([]);

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const response = await investorApi.getImagesByPropertyId(data[0].id);
        if (response.status === 200 && Array.isArray(response.data)) {
          const imageUrls = response.data.map((img) => img.ImageURL);
          setImages(imageUrls);
          
          const mediaWithType = imageUrls.map(url => ({
            type: 'image',
            url: url
          }));
          setAllMedia(mediaWithType);
        } else {
          console.warn("Unexpected image response format", response.data);
        }
      } catch (err) {
        console.error("Image fetch error:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchImages();
  }, [data[0].id]);

  useEffect(() => {
    const fetchVideos = async () => {
      if (!data[0].id) return;

      const setdata = {
        type: data[0].type,
        reference_id: data[0].id,
      };

      try {
        const response = await investorApi.getPropertyVideos(setdata);
      
        
        if (response.data && Array.isArray(response.data.data)) {
          const videos = response.data.data.map(video => ({
            type: 'video',
            url: video.video_url,
            id: video.id
          }));
          setPropertyVideos(videos);
          
          setAllMedia(prev => {
            const mediaWithType = videos.concat(prev);
            return mediaWithType;
          });
        }
      } catch (error) {
        console.error("Error fetching property videos:", error);
      }
    };
    fetchVideos();
  }, [data[0].id, data[0].type]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!modalOpen) return;
      switch (e.key) {
        case "ArrowRight":
          if (currentIndex < allMedia.length - 1) {
            setCurrentIndex((prev) => prev + 1);
            setCurrentType(allMedia[currentIndex + 1].type);
          }
          break;
        case "ArrowLeft":
          if (currentIndex > 0) {
            setCurrentIndex((prev) => prev - 1);
            setCurrentType(allMedia[currentIndex - 1].type);
          }
          break;
        case "Escape":
          closeModal();
          break;
        default:
          break;
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [modalOpen, currentIndex, allMedia]);

  const openModal = (index = 0) => {
    setCurrentIndex(index);
    setCurrentType(allMedia[index].type);
    setModalOpen(true);
  };

  const closeModal = () => setModalOpen(false);

  // Render different layouts based on screen size and media count
  const renderMediaGrid = () => {
    if (allMedia.length === 0) return null;
    
    // MOBILE LAYOUT (all screen sizes below 600px)
    if (isMobile) {
      return renderMobileLayout();
    }
    
    // TABLET & DESKTOP LAYOUTS
    return renderDesktopTabletLayout();
  };

  // Mobile layout - simple carousel style
  const renderMobileLayout = () => {
    // Show only first 3 items on mobile with indicators
    const visibleItems = allMedia.slice(0, 3);
    
    return (
      <Box sx={{ width: '100%', position: 'relative' ,marginTop:1}}>
        {/* Main media display */}
        <Box
          onClick={() => openModal(0)}
          sx={{
            width: '100%',
            height: {
              xs: '40vh',
              sm: '45vh'
            },
            overflow: 'hidden',
            cursor: 'pointer',
            borderRadius: '15px',
            position: 'relative'
          }}
        >
          {renderMediaItem(allMedia[0], 60)}
          
          {/* Image count indicator */}
            {/* {allMedia.length > 1 && (
              <Box
                sx={{
                  position: 'absolute',
                  bottom: 10,
                  right: 10,
                  backgroundColor: 'rgba(0,0,0,0.7)',
                  color: 'white',
                  padding: '4px 12px',
                  borderRadius: '20px',
                  fontSize: '14px',
                  fontWeight: 'bold'
                }}
              >
                {allMedia.length} photos/videos
              </Box>
            )} */}
        </Box>

        {/* Thumbnail row below main image */}
        {/* {allMedia.length > 1 && (
          <Box sx={{ 
            display: 'flex', 
            gap: '8px', 
            marginTop: '10px',
            overflowX: 'auto',
            paddingBottom: '5px'
          }}>
            {allMedia.slice(1).map((media, i) => (
              <Box
                key={i}
                onClick={() => openModal(i + 1)}
                sx={{
                  width: '80px',
                  height: '60px',
                  minWidth: '80px',
                  overflow: 'hidden',
                  cursor: 'pointer',
                  borderRadius: '8px',
                  position: 'relative',
                  flexShrink: 0
                }}
              >
                {renderMediaItem(media, 20)}
                
                
                {media.type === 'video' && (
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 3,
                      left: 3,
                      backgroundColor: 'rgba(0,0,0,0.7)',
                      color: 'white',
                      padding: '1px 4px',
                      borderRadius: '3px',
                      fontSize: '8px',
                      fontWeight: 'bold'
                    }}
                  >
                    VIDEO
                  </Box>
                )}
              </Box>
            ))}
          </Box>
        )} */}
      </Box>
    );
  };

  // Desktop and Tablet layout
  const renderDesktopTabletLayout = () => {
    // For single media item
    if (allMedia.length === 1) {
      return renderSingleMediaLayout();
    }
    
    // For multiple media items
    return renderMultipleMediaLayout();
  };

  // Single media layout
  const renderSingleMediaLayout = () => {
    const media = allMedia[0];
    return (
      <Box
        onClick={() => openModal(0)}
        sx={{
          width: '100%',
          height: {
            sm: '45vh',
            md: '50vh',
            lg: '55vh'
          },
          overflow: 'hidden',
          cursor: 'pointer',
          borderRadius: '20px',
          position: 'relative',
          marginTop:1
        }}
      >
        {renderMediaItem(media, 80)}
      </Box>
    );
  };

  // Multiple media layout for desktop/tablet
  const renderMultipleMediaLayout = () => {
    const containerHeight = {
      sm: '40vh',  // Tablet
      md: '45vh',  // Small desktop
      lg: '50vh'   // Large desktop
    };

    return (
      <Box sx={{ 
        display: 'flex', 
        width: '100%', 
        height: containerHeight,
        gap: '10px' ,
        marginTop:"10px",
        marginTop:1
      }}>
        {/* Main media item (left side) */}
        <Box
          onClick={() => openModal(0)}
          sx={{
            width: isTablet ? '60%' : '50%',
            height: '100%',
            overflow: 'hidden',
            cursor: 'pointer',
            borderRadius: '20px 0 0 20px',
            position: 'relative'
          }}
        >
          {renderMediaItem(allMedia[0], isTablet ? 40 : 60)}
        </Box>

        {/* Thumbnail grid (right side) */}
        <Box sx={{
          width: isTablet ? '40%' : '50%',
          height: '100%',
          display: 'grid',
          gap: '8px',
          // Adjust grid based on device
          gridTemplateColumns: isTablet ? '1fr' : 'repeat(2, 1fr)',
          gridTemplateRows: isTablet ? 'repeat(4, 1fr)' : 'repeat(2, 1fr)',
        }}>
          {allMedia.slice(1, isTablet ? 5 : 5).map((media, i) => {
            // For tablets, show up to 4 thumbnails in a column
            // For desktop, show up to 4 thumbnails in 2x2 grid
            
            const borderRadius = getDynamicBorderRadius(
              i, 
              allMedia.length, 
              isTablet ? 'tablet' : 'desktop'
            );

            return (
              <Box
                key={i}
                onClick={() => openModal(i + 1)}
                sx={{
                  width: '100%',
                  height: '100%',
                  overflow: 'hidden',
                  cursor: 'pointer',
                  borderRadius: borderRadius,
                  position: 'relative'
                }}
              >
                {renderMediaItem(media, isTablet ? 25 : 30)}
                
                {/* Show +X more on the last visible thumbnail */}
                {((isTablet && i === 3 && allMedia.length > 5) || 
                  (!isTablet && i === 3 && allMedia.length > 5)) && (
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      backgroundColor: 'rgba(49, 48, 48, 0.7)',
                      color: '#fff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: isTablet ? '1.2rem' : '1.5rem',
                      fontWeight: 'bold',
                      backdropFilter: 'blur(1px)',
                      borderRadius: 'inherit',
                    }}
                  >
                    +{allMedia.length - 5} more
                  </Box>
                )}
              </Box>
            );
          })}
        </Box>
      </Box>
    );
  };

  // Helper to render individual media item (image or video)
  const renderMediaItem = (media, playIconSize) => {
    return media.type === 'image' ? (
      <Box
        component="img"
        src={media.url}
        alt="property-media"
        sx={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          transition: 'transform 0.3s ease',
          '&:hover': {
            transform: 'scale(1.05)'
          }
        }}
      />
    ) : (
      <>
        <Box
          component="video"
          src={media.url}
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            transition: 'transform 0.3s ease',
            '&:hover': {
              transform: 'scale(1.05)'
            }
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(0,0,0,0.2)',
            transition: 'background-color 0.3s ease',
            '&:hover': {
              backgroundColor: 'rgba(0,0,0,0.4)'
            }
          }}
        >
          <PlayCircleOutlineIcon 
            sx={{ 
              fontSize: playIconSize, 
              color: 'white',
              cursor: 'pointer'
            }} 
          />
        </Box>
        {/* Video indicator badge */}
        <Box
          sx={{
            position: 'absolute',
            top: 10,
            left: 10,
            backgroundColor: 'rgba(0,0,0,0.7)',
            color: 'white',
            padding: '4px 8px',
            borderRadius: '4px',
            fontSize: {
              xs: '10px',
              sm: '11px',
              md: '12px'
            },
            fontWeight: 'bold'
          }}
        >
          VIDEO
        </Box>
      </>
    );
  };

  // Helper function to determine thumbnail border radius
  const getDynamicBorderRadius = (index, totalMedia, device = 'desktop') => {
    if (device === 'tablet') {
      // Tablet - single column layout
      if (index === 0) return '0 20px 0 0';
      if (index === 3) return '0 0 20px 0';
      return '0';
    }
    
    // Desktop - 2x2 grid layout
    if (totalMedia === 2) {
      return index === 0 ? '0 20px 20px 0' : '0';
    }

    if (totalMedia === 3) {
      if (index === 0) return '0 20px 0 0';
      if (index === 1) return '0 0 20px 0';
      return '0';
    }

    // For 4+ media
    if (index === 0) return '0 0px 0 0';
    if (index === 1) return '0 20px 0 0';
    if (index === 2) return '0 0 0 0';
    if (index === 3) return '0 0 20px 0';
    return '0';
  };

  return (
    <Box sx={{ 
      width: "100%", 
      minHeight: {
        xs: "40vh",
        sm: "45vh",
        md: "50vh"
      }, 
      position: "relative" 
    }}>
      {loading ? (
        <Box
          sx={{
            height: {
              xs: "45vh",
              sm: "45vh",
              md: "50vh"
            },
            background: "#eee",
            borderRadius: "4px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Box>
      ) : allMedia.length > 0 ? (
        <Box sx={{
          paddingBottom: {
            xs: "25rem",
            sm: "20rem",
            md: "18rem",
            lg: "17rem"
          },
        }}>
          {renderMediaGrid()}
          <Box
            sx={{
              width: "100%",
              position: "absolute",
              bottom: {
                xs: 20,
                sm: -20,
                md: -20,
              },
              left: 0,
              marginBottom: "30px",
            }}
          >
            <PropertyDetails data={data} type={type} />
          </Box>
        </Box>
      ) : (
        <Box sx={{
          height: {
            xs: "40vh",
            sm: "45vh",
            md: "50vh"
          },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#f5f5f5",
          borderRadius: "10px"
        }}>
          <Typography variant="body1" color="textSecondary">
            No media available
          </Typography>
        </Box>
      )}

      {/* Responsive Media Modal */}
      <Modal
        open={modalOpen}
        onClose={closeModal}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          outline: 'none'
        }}
      >
        <Box
          sx={{
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.95)',
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: {
              xs: 1,
              sm: 2,
              md: 3
            }
          }}
          onClick={closeModal}
        >
          <IconButton
            onClick={closeModal}
            sx={{
              position: 'absolute',
              top: {
                xs: 10,
                sm: 20
              },
              right: {
                xs: 10,
                sm: 20
              },
              color: '#fff',
              zIndex: 1,
              backgroundColor: 'rgba(0,0,0,0.5)',
              '&:hover': {
                backgroundColor: 'rgba(0,0,0,0.7)'
              }
            }}
          >
            <CloseIcon fontSize={isMobile ? "medium" : "large"} />
          </IconButton>
          
          <Box
            sx={{
              position: 'relative',
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Media counter */}
            <Box sx={{
              position: 'absolute',
              top: {
                xs: 10,
                sm: 20
              },
              left: {
                xs: 10,
                sm: 20
              },
              color: '#fff',
              fontSize: {
                xs: '14px',
                sm: '16px'
              },
              backgroundColor: 'rgba(0,0,0,0.5)',
              padding: '4px 12px',
              borderRadius: '20px',
              zIndex: 1
            }}>
              {currentIndex + 1} / {allMedia.length}
            </Box>

            {currentIndex > 0 && (
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  setCurrentIndex((prev) => prev - 1);
                  setCurrentType(allMedia[currentIndex - 1].type);
                }}
                sx={{
                  position: 'absolute',
                  left: {
                    xs: 5,
                    sm: 20
                  },
                  zIndex: 1,
                  color: '#fff',
                  backgroundColor: 'rgba(0,0,0,0.5)',
                  '&:hover': {
                    backgroundColor: 'rgba(0,0,0,0.7)'
                  }
                }}
              >
                <ChevronLeftIcon fontSize={isMobile ? "medium" : "large"} />
              </IconButton>
            )}
            
            {/* Media content */}
            <Box sx={{
              width: '100%',
              height: {
                xs: '70%',
                sm: '80%',
                md: '85%'
              },
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              {currentType === 'image' ? (
                <Box
                  component="img"
                  src={allMedia[currentIndex]?.url}
                  alt={`property-${currentIndex}`}
                  sx={{
                    maxWidth: '95%',
                    maxHeight: '95%',
                    objectFit: 'contain',
                    borderRadius: '8px'
                  }}
                />
              ) : (
                <Box
                  component="video"
                  src={allMedia[currentIndex]?.url}
                  controls
                  autoPlay
                  sx={{
                    width: {
                      xs: '95%',
                      sm: '90%',
                      md: '85%'
                    },
                    maxHeight: '95%',
                    borderRadius: '8px'
                  }}
                />
              )}
            </Box>

            {currentIndex < allMedia.length - 1 && (
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  setCurrentIndex((prev) => prev + 1);
                  setCurrentType(allMedia[currentIndex + 1].type);
                }}
                sx={{
                  position: 'absolute',
                  right: {
                    xs: 5,
                    sm: 20
                  },
                  zIndex: 1,
                  color: '#fff',
                  backgroundColor: 'rgba(0,0,0,0.5)',
                  '&:hover': {
                    backgroundColor: 'rgba(0,0,0,0.7)'
                  }
                }}
              >
                <ChevronRightIcon fontSize={isMobile ? "medium" : "large"} />
              </IconButton>
            )}

            {/* Thumbnail strip at bottom for mobile/tablet */}
            {(isMobile || isTablet) && allMedia.length > 1 && (
              <Box sx={{
                position: 'absolute',
                bottom: 20,
                left: 0,
                right: 0,
                display: 'flex',
                justifyContent: 'center',
                gap: '8px',
                overflowX: 'auto',
                padding: '0 10px'
              }}>
                {allMedia.map((_, i) => (
                  <Box
                    key={i}
                    onClick={(e) => {
                      e.stopPropagation();
                      setCurrentIndex(i);
                      setCurrentType(allMedia[i].type);
                    }}
                    sx={{
                      width: '8px',
                      height: '8px',
                      borderRadius: '50%',
                      backgroundColor: i === currentIndex ? '#fff' : 'rgba(255,255,255,0.5)',
                      cursor: 'pointer',
                      transition: 'background-color 0.3s'
                    }}
                  />
                ))}
              </Box>
            )}
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default PropertyImages;